import React, { useEffect, useState } from "react";
import "./GrayBoxWithText.css";

const GrayBoxWithText = (props) => {
  const [showPincodeModal, setShowPincodeModal] = useState(false);

  return (
    <section className="GrayBoxWithText">
      <div className="card">
        <div>
          <p className="card_text">Pincode</p>
        </div>

        <div onClick={props?.onClick}>
          <p className="right_side_text">Enter Pincode</p>
        </div>
      </div>
    </section>
  );
};

export default GrayBoxWithText;
